import { enumToNameWithDefault, rawValueToEnumWithDefault } from '@ps-smart-cp/ppfw-client';
import { userMaintenanceOrderItemNameConfig } from './UserMaintenanceOrderItem.name';

enum UserMaintenanceOrderItem {
  /** ユーザID */
  userId = '1',
  /** 予備名称1 */
  mstSpareNameOne = '2',
  /** 予備名称2 */
  mstSpareNameTwo = '3',
}

const userMaintenanceOrderItemMap = new Map([
  ['1', UserMaintenanceOrderItem.userId],
  ['2', UserMaintenanceOrderItem.mstSpareNameOne],
  ['3', UserMaintenanceOrderItem.mstSpareNameTwo],
]);

const rawValueToUserMaintenanceOrderItem = rawValueToEnumWithDefault(
  userMaintenanceOrderItemMap,
  UserMaintenanceOrderItem.userId,
);

const userMaintenanceOrderItemToDisplay = enumToNameWithDefault(
  UserMaintenanceOrderItem,
  userMaintenanceOrderItemNameConfig,
);

const userMaintenanceOrderItemToDisplayWithPrefix = enumToNameWithDefault(
  UserMaintenanceOrderItem,
  userMaintenanceOrderItemNameConfig,
  true,
);

export {
  UserMaintenanceOrderItem,
  rawValueToUserMaintenanceOrderItem,
  userMaintenanceOrderItemToDisplay,
  userMaintenanceOrderItemToDisplayWithPrefix,
};
